module.exports = __webpack_public_path__ + "assets/img/backgroundPicture.6311e426.png";